<template>
  <v-container>
    <v-row>
      <v-col v-for="park in parks" cols="3" class="pa-1">
        <v-card @click="openOverlay(park.id)">
          <v-card-title>
            <v-icon
              :color="colorForPark(park['online'], park['installed'])"
              size="32"
              icon="mdi-circle"
              style="background-color: black; border-radius: 50%;"
            />
            {{ park.name }}
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
  <v-overlay v-model="overlay" class="d-flex justify-center align-center">
    <v-alert
      v-model="showAlert"
      :type="typeAlert"
      :title="titleAlert"
      :text="msgAlert"
      density="compact"
      style="margin-bottom: 12px"
      closable
    />
    <v-progress-circular v-if="loadingOverlay" indeterminate color="red" size="160" width="16"/>
    <v-card v-else>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col v-for="(value, key) in overlayParkData" cols="2">
              <p><b>{{ key }}:</b> {{ value }}</p>
            </v-col>
            <v-col>
              <p class="text-h5">TODO CHECK CONNECTIONS</p>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-overlay>
</template>

<script setup>
import { ref, onMounted, reactive } from 'vue';
import axios from 'axios';
import { endpoint } from "../remote/utils.js";

const parks = reactive([]);

const showAlert = ref(false);
const typeAlert = ref('error');  // success, info, warning, error
const msgAlert = ref('');
const titleAlert = ref('');

function errorAlert(title, msg) {
  showAlert.value = true;
  typeAlert.value = 'error';
  titleAlert.value = title;
  msgAlert.value = msg;
}

const overlay = ref(false);
const loadingOverlay = ref(false);
const overlayParkData = ref({});
const overlayCPData = ref([]);


async function fetchParkData(park_id) {
  try {
    const response = await axios.get(endpoint(`internal/current/parks/${park_id}/`), {
      withCredentials: true
    });
    overlayCPData.value = response.data['chargingstations'];
    delete response.data['chargingstations'];
    overlayParkData.value = response.data;
  } catch (e) {
    errorAlert('Impossible to load the park', e.toString());
  }
}

async function openOverlay(park_id) {
  loadingOverlay.value = true;
  overlay.value = true;
  await fetchParkData(park_id);
  loadingOverlay.value = false;
}

function colorForPark(online, installed) {
  if (installed && online) {
    return '#00FF00';
  } else if (!installed) {
    return '#808080';
  } else {
    return '#FF0000';
  }
}

async function refreshParks() {
  await axios.get(endpoint('internal/current/access_status/'), {
    withCredentials: true
  }).then(response => {
    parks.splice(0, parks.length, ...response.data);
  }).catch(() => {
    alert("error loading parks");
  });
}

onMounted(async () => {
  loadingOverlay.value = true;
  overlay.value = true;
  await refreshParks();
  overlay.value = false;
});

</script>

<style scoped>

</style>
